module.exports = __webpack_public_path__ + "img/icon-44.24e5f027.svg";